import Input from "./Input";
import IMask from "imask/holder";
import "imask/masked/pattern";

export default class InputWithMask extends Input {

    imask;

    constructor(element, form) {
        super(element, form);

        this.imask = IMask(this.inputElement, {
            mask: '+tel',
            blocks: {
                tel: {
                  mask: /^[0-9 \-()]+$/,
                },
            },
            lazy: true,
        });
        
        this.addListeners();
    }

    addListeners() {
        if (!this.imask) {
            return;
        }

        this.imask.on('accept', () => {
            this.value = this.imask.value;
        });
    }
}
